export default "__VITE_ASSET__x3cO_3HU__"